/** 诚意金记录 */
<template>
  <div class="noipAtlas">
    <!-- header -->
    <div class="headerView">
      <div class="filter">
        <label class="text">选择班主任:</label>
        <FilterBar
          :data="class_teacher_data"
          :index="-1"
          option-key="realname,name"
          @change="changeTeamEvent"
          @scroll="scrollTeamEvent"
        />
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="list">
      <table class="infoTable">
        <tbody>
          <tr class="infoLabel">
            <th class="text">真实名字-昵称</th>
            <th class="text">账号</th>
            <th class="text">是否分享/当月</th>
            <th class="text">操作</th>
          </tr>
          <tr
            :class="`infoValue ${
              (data.length % 2 === 0 && index % 2 !== 0) ||
              (data.length % 2 !== 0 && index % 2 === 0)
                ? 'blue'
                : 'white'
            }`"
            v-for="(item, index) in data"
            :key="item.id"
          >
            <td class="text">{{ item.realname }} - {{ item.name }}</td>
            <td class="text">{{ item.owner }}</td>
            <td class="text">
              {{ item.is_share_orange_gold_poster === true ? "是" : "否" }}
            </td>
            <td class="text">
              <button class="btn" @click="goOrangeGoldPage(item)">
                进入诚意金
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <el-pagination
        background
        layout="prev, pager, next"
        :total="total_count"
        :current-page="page"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { TeamTypes, UserTypes } from "@/store/types";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import FilterBar from "@/components/FilterBar.vue";

export default {
  name: "MyAllStudent",
  components: {
    FilterBar,
  },
  data() {
    return {
      filter: {
        class_teacher: null,
        search: "",
      },
    };
  },
  computed: {
    ...mapState({
      page: (state) => state.user.page,
      total_count: (state) => state.user.total_count,
      data: (state) => state.user.data,

      class_teacher_page: (state) => state.team.class_teacher.page,
      class_teacher_load_more: (state) => state.team.class_teacher.load_more,
      class_teacher_data: (state) => state.team.class_teacher.data,
    }),
  },

  created() {},
  methods: {
    ...mapMutations({}),
    ...mapActions({
      fetchUserListData: UserTypes.FETCH_DATA,
      fetchClassTeacherListData: TeamTypes.FETCH_LIST_DATA_CLASS_TEACHER,
    }),

    // 请求班主任列表数据
    loadClassTeacherData(tag = "first") {
      let page = this.class_teacher_page;
      if (tag === "next") {
        // 下一页
        page += 1;
      } else {
        // 首页
        page = 1;
      }
      this.fetchClassTeacherListData({
        page: page,
        is_replace: false,
        hasLoading: false,
      });
    },

    //请求诚意金记录数据
    loadUserData(page = 1) {
      let dic = {
        page: page,
        hasLoading: false,
      };

      if (this.filter.class_teacher) {
        dic = { ...dic, class_teacher: this.filter.class_teacher };
      }

      this.fetchUserListData(dic);
    },

    //修改页码
    changePage(val) {
      this.loadUserData(val);
    },

    // 进入诚意金记录页
    goOrangeGoldPage(item) {
      // console.log(item.owner);
      this.$router.push(
        `/OrangeGoldRecord?owner=${encodeURIComponent(item.owner)}`
      );
    },

    // -----------FilterBar 事件
    // 班主任更改事件
    changeTeamEvent(item, index) {
      if (index !== -1) {
        this.filter.class_teacher = item.owner;
      } else {
        this.filter.class_teacher = "";
      }

      this.loadUserData();
    },
    // 班主任滚动事件
    scrollTeamEvent() {
      if (this.class_teacher_load_more) {
        this.loadClassTeacherData("next");
      }
    },
  },
  mounted() {
    this.loadClassTeacherData();
    this.loadUserData();
  },
};
</script>
<style scoped lang="less">
.noipAtlas {
  // width: 100%;
  margin-left: 180px;
  padding: 20px;
  width: calc(100% - 220px);

  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #f5f5f5;
  .list {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    border-radius: 10px;
    padding: 15px;
    text-align: center;
    min-width: 500px;
    .infoTable {
      padding: 20px;
      width: 100%;
      border-spacing: 0px;
      margin-bottom: 20px;
      .infoLabel {
        background-color: #5f0aff;
        height: 70px;
        color: white;
        &.one {
          height: 30px;
          line-height: 30px;
          border-bottom: solid 1px #5f0aff;
          border-top: solid 1px #5f0aff;
          font-size: 13px;
          background-color: transparent;
          color: #333333;
          .text {
            border-right: solid 1px #5f0aff;
          }
          .text:first-child {
            border-left: solid 1px #5f0aff;
          }
        }
        .text {
          text-align: center;
          vertical-align: middle;
          padding: 5px;
        }
      }
      .infoValue {
        height: 60px;
        font-size: 16px;
        color: #333;
        &.one {
          height: 30px;
          line-height: 30px;
          font-size: 13px;
          border-top: solid 1px #5f0aff;
          .text:first-child {
            border-left: solid 1px #5f0aff;
          }
          .text {
            border-right: solid 1px #5f0aff;
          }
        }

        .one:last-child {
          border-bottom: solid 1px #5f0aff;
        }
        &.blue {
          background-color: #f2f7ff;
        }
        &.white {
          background-color: #ffffff;
        }
        .text {
          text-align: center;
          vertical-align: middle;
          padding: 5px;
        }
        .btn {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          background: #5f0aff;
          border-radius: 16px;
          color: #fff;
          padding: 0 14px;
          cursor: pointer;
          font-size: 14px;
        }
      }
    }
  }

  .headerView {
    flex-direction: row;
    display: flex;
    align-items: center;
    border-radius: 10px;
    background: #fff;
    font-size: 20px;
    padding: 20px;
    margin-bottom: 15px;
    justify-content: space-between;
    .filter {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 30px;
      .text {
        color: #333333;
        font-size: 16px;
        margin-right: 15px;
      }
    }
    .inputView {
      input {
        height: 36px;
        border-radius: 18px;
        background: #ecf3ff;
        font-size: 16px;
        color: #999999;
        padding-left: 10px;
        border: none;
        margin-right: 10px;
      }
      .btn {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        background: #5f0aff;
        border-radius: 16px;
        color: #fff;
        padding: 0 14px;
        cursor: pointer;
        font-size: 14px;
      }
      .item {
        display: inline-block;
        padding: 10px 15px;
        cursor: pointer;
        /* background-color: #ecf3ff; */
        &.select {
          background-color: #5f0aff;
          color: #ffffff;
        }
      }
    }
  }
  .topView {
    background-color: white;
    width: calc(100% - 40px);
    border-radius: 10px;
    font-size: 20px;
    padding: 20px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 15px;
    .itemView {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 10px;
      margin-right: 10px;
      &.btnView {
        font-size: 16px;
        border: solid 1px #5f0aff;
        border-radius: 20px;
        background-color: #ecf3ff;
        color: #333333;
        overflow: hidden;
        display: inline-block;
      }
      .text {
        font-size: 14px;
        color: #333333;
        margin-right: 10px;
        color: #5f0aff;
      }
      .optionBtn {
        padding: 10px 10px;
        border-radius: 5px;
        background-color: #ecf3ff;
        color: #333333;
        font-size: 13px;
        margin-right: 10px;
        cursor: pointer;
        display: inline-block;
        &.select {
          background-color: #5f0aff;
          color: #ffffff;
        }
      }
      .item {
        display: inline-block;
        padding: 10px 15px;
        cursor: pointer;
        /* background-color: #ecf3ff; */
        &.select {
          background-color: #5f0aff;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
